<template>
  <div>
    <button
      class="salesflow-btn salesflow-btn-small salesflow-btn-outline"
      @click="openModal()"
    >
      {{ __('Criar novo e-mail') }}
    </button>
    <BModal
      id="modal-new-mail"
      modal-class="modal-no-header-no-footer"
      ref="modal-new-mail"
      hide-header="hide-header"
      hide-footer="hide-footer"
    >
      <template slot="default">
        <button
          class="close"
          type="button"
          aria-label="Close"
          @click="$refs['modal-new-mail'].hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title align-items-center text-center">
          {{ __('Novo e-mail') }}
          <h6 class="modal-subtitle mt-1">
            {{ __('Preencha os dados do e-mail') }}
          </h6>
        </h4>
        <ModalForm
          @saved="handleSave"
          :user="user"
        />
      </template>
    </BModal>
  </div>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import ModalForm from './ModalForm';

export default {
  components: {
    BModal,
    ModalForm,
  },

  props: [
    'user',
  ],

  methods: {
    openModal () {
      this.$refs['modal-new-mail'].show();

      setTimeout(() => {
        document.querySelector('#mail-title').focus();
      }, 500);
    },

    handleSave ({ id }) {
      window.location = `/mail/${id}/template`;
    },
  },
};
</script>
